import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/shop/src/components/common/AnnouncementBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientScripts"] */ "/app/apps/shop/src/components/common/ClientScripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/shop/src/components/common/Error.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/shop/src/components/common/PageWrapper/PageClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/shop/src/components/common/Telemetry/TelemetryManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalProvider"] */ "/app/apps/shop/src/contexts/ModalContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/shop/src/contexts/OrderSetupContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreviewNavigationProvider"] */ "/app/apps/shop/src/contexts/PreviewNavigationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/shop/src/contexts/ReduxProdivder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","tolgeeApiKey","tolgeeApiUrl"] */ "/app/apps/shop/src/libs/config/client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["TolgeeNextProvider"] */ "/app/apps/shop/src/libs/tolgee/client.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.2.5_@babel+core@7.28.0_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react-dom@1_eocq57jkeunibbsz7bxjvo46qq/node_modules/next/dist/client/script.js");
